import { ODataSelect } from "../../../../Providers.Api/ODataQuery";
import { DateHelper } from "../../../../Common/DateHelper";

export class Announcement extends ODataSelect
{
    public Notification_Id = 0;
    public Notification_Title = '';
    public Notification_Priority = 0;
    public Notification_Record_Id = '';
    public Notification_Message = '';
    public Notification_Short_Message = '';
    public Notification_Reminders =  "";
    public Notification_Type = 0;
    public Notification_Status = '';
    public Notification_User_Email = '';
    public Notification_Sent = 0;
    public Notification_Target = 0;
    public Notification_Device = null;
    public Classification = '';
    public Subclassification = '';
    public Available_From = DateHelper.null();
    public Expiry_Date = DateHelper.null();
    public Has_Image = 0;
    public ImageURI = '';
    public ActionURI = '';
    public Node_Id = 0;

    public init(response: any, nodeId: number): Announcement
    {
        super.init(response, nodeId);
        this.Available_From = DateHelper.fromIsoByNode(response.Available_From, nodeId);
        this.Expiry_Date = DateHelper.fromIsoByNode(response.Expiry_Date, nodeId);
        return this;
    }
}

export class Device extends ODataSelect
{
    public Device_Id = 0;
    public Node_Id = 0;
    public Space_Id = '';
    public Device_Type = 0;
    public Device_Code = 0;
    public Device_Mode = 0;
    public Signage_Id = 0;
    public Device_Auth_Error = '';
    public Device_General_Error = '';
    public Device_OEM_Mode = 0;
    public Device_OEM_Client_ImageURI = '';
    public Device_OEM_Brand_ImageURI = '';
    public Device_MAC = '';
    public Device_IP = '';
}